import { Col, Row } from 'react-bootstrap';

import { FISCAL_PATTERN_OPTIONS, type FiscalPattern } from 'utils/fiscalPeriods';

import type { FiscalPeriodPatch } from './shared';

interface Props {
  readonly pattern: FiscalPattern;
  readonly patch: FiscalPeriodPatch;
}

/** Card picker for 4-4-5 / 4-5-4 / 5-4-4 quarter patterns. */
export const PatternPicker = ({ pattern, patch }: Props) => (
  <>
    <h6 className="mb-2">Pattern — where the 5-week period sits in each quarter</h6>
    <Row className="g-3 mb-4">
      {FISCAL_PATTERN_OPTIONS.map((opt) => {
        const selected = pattern === opt.value;
        return (
          <Col key={opt.value} xs={12} md={4}>
            <button
              type="button"
              className={`fiscal-period-editor__pattern border rounded p-3 h-100 ${selected ? 'border-primary' : ''}`}
              aria-pressed={selected}
              onClick={() => patch({ pattern: opt.value })}
            >
              <div className="fiscal-period-editor__week-bar">
                {opt.weeks.map((w, i) => (
                  <span key={i} className="fiscal-period-editor__week-block" style={{ flex: w }}>
                    {w}
                  </span>
                ))}
              </div>
              <div className="fw-semibold">{opt.value}</div>
              <div className="text-muted small">{opt.rationale}</div>
            </button>
          </Col>
        );
      })}
    </Row>
  </>
);
